import {
  API_HOST,
  API_HOST_JAVA,
  API_IMG_HOST
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import VueAxios from 'vue-axios'
const axiosJava = axios.create({
  baseURL: API_HOST_JAVA
})
axiosJava.defaults.timeout = 1000 * 15
axiosJava.defaults.headers.authKey = Lockr.get('authKey')
axiosJava.defaults.headers.sessionId = Lockr.get('sessionId')
axiosJava.defaults.headers['Content-Type'] = 'application/json'

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}
// 返回处理
axiosJava.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code === -1) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    Lockr.rm('firstRoutePath')
    // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101 && response.data.code != 200) {
    // _g.toastMsg('error', response.data.error)
    if (response.data.code == 401) {
      // 跳转到登录页
      router.push({path: '/login'})
    }
    return response
  } else {
    // console.log(response, '正常拿到数据')
    // 处理数据为空，赋值——
    // if (response.data.code === '200') {
    //   let list = response.data.result || []
    //   let isArray = list instanceof Array
    //   if (!isArray) {
    //     // 说明不是数组
    //     list = list.list || []
    //   }
    //   if (list.length === 0) {
    //     return response
    //   } else {
    //     list.forEach(item => {
    //       for (const key in item) {
    //         if (key !== 'url' && (item[key] === '' || item[key] === null || item[key] === undefined || item[key] === 'null' || item[key] === 'undefined')) {
    //           item[key] = '——'
    //         }
    //       }
    //     })
    //     if (isArray) {
    //       response.data.result = list
    //     } else {
    //       response.data.result.list = list
    //     }
    //     let backData = {
    //       data: response.data,
    //       config: response.config,
    //       status: response.status,
    //       headers: response.headers,
    //       request: response.request,
    //       statusText: response.statusText,
    //     }
    //     console.log(backData, '正常拿到数据111')
    //     return backData
    //   }
    // } else {
    //   return response
    // }
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 客户分析查询
export function customerAnalyseSearch (queryJson) {
  let url = 'anlys/customer/query'
  return axiosJava.post(url, queryJson)
}
// 保存为单图
export function analyseSaveSingle (data) {
  let url = 'anlys/figure/add'
  return axiosJava.post(url, data)
}
// 获取单图列表
export function getSingleList (page, limit, type, name, createUsrName, modelId) {
  let url = 'anlys/figure/query'
  return axiosJava.get(url, {
    params: {
      page: page,
      limit: limit,
      type: type,
      name: name,
      createUsrName: createUsrName,
      modelId: modelId
    }
  })
}
// 单图删除
export function deleteSingle (id) {
  let url = 'anlys/figure/delete'
  return axiosJava.delete(url, {
    params: {
      id: id
    }
  })
}
// 客户分析编辑保存
export function customerAnalyseSingleEdit (id, name, filterJson, modelId) {
  let url = 'anlys/figure/update'
  return axiosJava.post(url, {
    id: id,
    name: name,
    filterJson: filterJson,
    modelId: modelId
  })
}
// 行为分析查询
export function behaviorAnalyseSearch (queryJson) {
  let url = '/anlys/behavior/query'
  return axiosJava.post(url, queryJson)
}
// 行为分析查询
export function getDashBoardList (page, limit, name, createUserName) {
  let url = 'anlys/dashboard/query'
  return axiosJava.get(url, {
    params: {
      page: page,
      limit: limit,
      name: name,
      createUserName: createUserName
    }
  })
}
// 添加看板
export function addDashBoard (name) {
  let url = 'anlys/dashboard/addDashBoard'
  return axiosJava.post(url, {
    name: name
  })
}
// 看板删除
export function deleteDashboard (id) {
  let url = 'anlys/dashboard/deleteDashBoard'
  return axiosJava.delete(url, {
    params: {
      id: id
    }
  })
}
// 另存看板
export function saveAnotherDashBoard (id, name) {
  let url = 'anlys/dashboard/saveAs'
  return axiosJava.get(url, {
    params: {
      id: id,
      name: name
    }
  })
}
//  添加单图到看板 id  看板id figureId 单图id
export function addSingleChartToDashBoard (id, figureId) {
  let url = 'anlys/dashboard/addFigureToDashboard'
  return axiosJava.post(url, {
    id: id,
    figureId: figureId
  })
}
// 看板删除单图 id  看板id figureId 单图id
export function deleteSingleChartFromeDashBoard (id, figureId) {
  let url = 'anlys/dashboard/deleteFigureFromDashBoard'
  return axiosJava.get(url, {
    params: {
      id: id,
      figureId: figureId
    }
  })
}
// 数据看板中查询单图数据接口
export function getSingleChartDashBoard (figureId) {
  let url = 'anlys/figure/query4Dashboard'
  return axiosJava.post(url, {
    figureId: figureId
  })
}
// 获取单图列表
export function getDashBoardSingleChartList (page, limit, type, name, createUsrName, dashBoardId) {
  let url = 'anlys/figure/queryByBoardId'
  return axiosJava.get(url, {
    params: {
      page: page,
      limit: limit,
      type: type,
      name: name,
      createUsrName: createUsrName,
      dashBoardId: dashBoardId
    }
  })
}
// 修改标题
export function modifyDashBoardTitle (id, name) {
  let url = 'anlys/dashboard/updateDashBoardName'
  return axiosJava.get(url, {
    params: {
      name: name,
      id: id
    }
  })
}
// 更新看板
export function updateDashBoard (figureId, figures) {
  let url = 'anlys/dashboard/updateDashBoard'
  return axiosJava.post(url, {
    id: figureId,
    figures: figures
  })
}
// 单图详情
export function getSingleChartDetails (id) {
  let url = 'anlys/figure/queryById'
  return axiosJava.get(url, {
    params: {
      id: id
    }
  })
}
// 1.活码列表
export function getNimbleCodeList (params) {
  const url = '/nimbleCode/list'
  return axiosJava.get(url, {
    params: params
  })
}
// 2.添加活码
export function addNimbleCode (params) {
  const url = '/nimbleCode/add'
  return axiosJava.post(url, params)
}
// 3.删除活码
export function deleteNimbleCode (id) {
  let url = '/nimbleCode/del/' + id
  return axiosJava.delete(url)
}
// 4.禁用/启用活码
export function getNimbleCodeState (params) {
  const url = '/nimbleCode/state'
  return axiosJava.get(url, {
    params: params
  })
}
// 5.修改活码
export function updateNimbleCode (params) {
  const url = '/nimbleCode/update'
  return axiosJava.post(url, params)
}
// 分页查询订单
export function getOrderList (params) {
  let url = 'zy/order/page'
  return axiosJava.get(url, {
    params: params
  })
}
// 查询订单详情
export function getOrderDetail (orderId) {
  let url = 'zy/order/info/' + orderId
  return axiosJava.get(url)
}

// 获取角色权限列表-用于设置
export function systemAuthority (roleId) {
  // const url = 'zy/role/perms/' + roleId
  const url = 'zy/role/perms/' + roleId
  return axiosJava.get(url)
}
// 修改权限更新角色权限
export function saveAuthority (roleId, data) {
  const url = 'zy/role/perms/' + roleId
  return axiosJava.put(url, data)
}
export const SYSTEM_CODE = Object.freeze({
  'CLOUD_SHOP': '饮酒联盟',
  'ZY_MARKET': '二维码营销',
  'ZY_INTELLIQUOR': '智盈',
  'ZY_MEMBER': '国粉俱乐部',
  'ZY_GROUP': '云团',
  'CLOUD_BUSINESS': '经销商联谊会',
  'CLOUD_MARKET': '云销',
  'SAVOUR_WINE': '品鉴酒',
  'BIG_SCREEN': '大屏',
  'TERMINAL_MGR': '终端管理',
  'DRINK_ADVISORY': '饮品顾问',
  'SEALALTAR': '封坛',
  'BG_TASK_RELEASE': '业代任务发布'
})
// 取当前用户某个菜单下的可用按钮列表
export function butonsList (params) {
  const url = 'zy/company/getButtonByMenuIdList'
  return axiosJava.get(url, {
    params: params
  })
}
// 根据当前菜单获取menuId
export function getMenId (path) {
  let leftMenuList = Lockr.get('menuListLeft')
  let menuId = ''
  leftMenuList.map(item=> {
    let child = item.children || []
    child.map(it => {
      if (it.attributes.route == path) {
        menuId = it.id
      }
    })
  })
  return menuId
  // if (id == undefined || id == '') {
  // } else {
  //   let arr = id.split('-') || []
  //   if (arr.length !== 0) {
  //     let menuid = leftMenuList[(arr[0] - 1)].children[(arr[1] - 1)].menuId || ''
  //     return menuid
  //   }
  // }
}

// 获取用户列表
export function getMemberList (params) {
  let url = 'shop-user/page'
  return axiosJava.get(url, {
    params: params
  })
}
// 添加用户
export function addMemberList (params) {
  let url = 'shop-user'
  return axiosJava.post(url, params)
}
// 编辑用户
export function updateMemberList (params) {
  let url = 'shop-user/' + params.id
  return axiosJava.put(url, params)
}
// 删除用户
export function deleteMemberList (params) {
  let url = 'shop-user/' + params.id
  return axiosJava.delete(url, params)
}
// 用户小程序权限设置
export function saveUserArea (params) {
  let url = 'shop-user/saveUserArea '
  return axiosJava.post(url, params)
}
// 状态切换
export function stateMemberList (params) {
  let url = 'shop-user/' + params.id + '/' + params.state
  return axiosJava.put(url)
}
// 获取详情
export function getMemberDetail (params) {
  let url = 'shop-user/' + params.id
  return axiosJava.get(url, {
    params: params
  })
}
// 角色管理
export function getRoleList (params) {
  let url = 'shop-admin-group/page'
  return axiosJava.get(url, {
    params: params
  })
}
// 3、部门管理树状列表
export function getDepartmentList (params) {
  let url = 'department/list'
  return axiosJava.get(url, {
    params: params
  })
}
// 业务区域管理
// 1、业务区域管理新建// 编辑
export function addOrUpdate (params) {
  let url = 'businessArea/addOrUpdate'
  return axiosJava.post(url, params)
}
// 2、业务区域管理编辑
// export function addMemberList (params) {
//   let url = 'businessArea/addOrUpdate'
//   return axiosJava.post(url, params)
// }
// 3、区域管理列表
export function businessAreaList (params) {
  let url = 'businessArea/list'
  return axiosJava.get(url, {
    params: params
  })
}
// 4、区域管理详情
export function businessAreaDetail (params) {
  let url = 'businessArea/details'
  return axiosJava.get(url, {
    params: params
  })
}
// 5、删除业务区域
export function businessAreaDelete (params) {
  let url = 'businessArea/' + params.id
  return axiosJava.delete(url)
}
// 6、启用/禁用
export function changeStatusArea (params) {
  let url = 'businessArea/changeStatus'
  return axiosJava.put(url, params)
}
